<template>

    <v-modal :title="title">
        <template #body>
            <v-alert :message="error" />
            <v-alert v-if="automation.smart_sending" type="info">You have Smart Sending enabled, which means customers can only be emailed once every {{ project.send_interval }} {{ 'day' | pluralize(project.send_interval) }}.</v-alert>
            <p v-if="automation.is_active">Are you sure you want to stop:<br>{{ automation.name }}</p>
            <p v-else>Are you sure you want to start:<br>{{ automation.name }}</p>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :btn-style="automation.is_active ? 'danger' : 'success'" :loading="loading" @click.native="updateAutomation">{{ title }}</v-button>
        </template>
    </v-modal>

</template>

<script>

import CampaignApi from '@api/CampaignApi'

export default {

    data() {
        return {
            loading: false,
            error: null,
        }
    },

    computed: {

        automation() {
            return this.$store.getters['campaign/campaign'];
        },

        title() {
            return this.automation.is_active ? 'Stop Automation' : 'Start Automation';
        },

    },

    methods: {

        updateAutomation() {
            if (this.automation.is_active) {
                this.stopAutomation();
            } else {
                this.startAutomation();
            }
        },

        startAutomation() {
            this.loading = true;
            CampaignApi.startCampaign(this.automation.id)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('campaign/setParam', { is_active: true });
                    this.$store.commit('setAlertSuccess', this.$t('message.started'));
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        stopAutomation() {
            this.loading = true;
            CampaignApi.stopCampaign(this.automation.id)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('campaign/setParam', { is_active: false });
                    this.$store.commit('setAlertSuccess', this.$t('message.stopped'));
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
